// extracted by mini-css-extract-plugin
export default {"root":"style_root__mvGEk","frame":"style_frame__ajpfx"};